import { useMutation } from '@tanstack/react-query';
import { useState, type FormEvent, type ReactNode } from 'react';
import { ingresar } from '../api';
import { Boton, Error_ } from '../componentes/basicos';

export function Ingresar({ alEntrar }: { alEntrar: () => void }): ReactNode {
  const [email, setEmail] = useState('');
  const [clave, setClave] = useState('');

  const entrar = useMutation({
    mutationFn: () => ingresar({ email, clave }),
    onSuccess: alEntrar,
  });

  function enviar(e: FormEvent): void {
    e.preventDefault();
    entrar.mutate();
  }

  return (
    <div className="flex min-h-screen">
      {/* La marca, solo en ancho: en el teléfono el formulario va primero. */}
      <aside className="relative hidden w-[44%] flex-col justify-between overflow-hidden bg-gradient-to-br from-acento via-marino to-marino-profundo p-10 text-white lg:flex">
        <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-lima/10" aria-hidden="true" />
        <div className="absolute -bottom-32 -left-16 h-96 w-96 rounded-full bg-naranja/10" aria-hidden="true" />
        <img src="/del-pastor-escudo.svg" alt="Del Pastor" className="relative h-24 w-24 drop-shadow-lg" />
        <div className="relative">
          <p className="font-titulo text-4xl leading-tight">
            De la orden de compra
            <br />
            <span className="italic text-lima">a lo que de verdad se pagó.</span>
          </p>
          <p className="mt-4 max-w-sm text-sm text-white/70">
            Órdenes, entregas, recepción y cartera de Del Pastor, en un solo hilo.
          </p>
        </div>
        <p className="relative text-xs text-white/50">Alcanza S.A. · Lácteos de cabra</p>
      </aside>

      <div className="flex flex-1 items-center justify-center p-4">
        <form
          onSubmit={enviar}
          className="w-full max-w-sm space-y-4 rounded-2xl border border-borde bg-superficie p-7 shadow-suave"
        >
          <div>
            <img src="/del-pastor-escudo.svg" alt="" className="mb-3 h-14 w-14 lg:hidden" />
            <h1 className="text-3xl font-semibold">ManejoAlcanza</h1>
            <p className="mt-1 text-sm text-tenue">Sistema interno de Alcanza S.A.</p>
          </div>

          <label className="block">
            <span className="text-xs font-medium text-tenue">Correo</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
              className="mt-1 h-11 w-full rounded-lg border border-borde px-3"
            />
          </label>

          <label className="block">
            <span className="text-xs font-medium text-tenue">Contraseña</span>
            <input
              type="password"
              value={clave}
              onChange={(e) => setClave(e.target.value)}
              autoComplete="current-password"
              required
              minLength={12}
              className="mt-1 h-11 w-full rounded-lg border border-borde px-3"
            />
          </label>

          {/*
            El error que llega del servidor es siempre el mismo, exista o no el
            correo. Aquí se muestra tal cual: distinguirlos en la interfaz
            desharía el cuidado que se tuvo en el servidor.
          */}
          {entrar.isError && <Error_>{(entrar.error as Error).message}</Error_>}

          <div className="grid">
            <Boton submit deshabilitado={entrar.isPending}>
              {entrar.isPending ? 'Entrando…' : 'Entrar'}
            </Boton>
          </div>
        </form>
      </div>
    </div>
  );
}
